import * as types from '../types/preschoolEntity'

// ---- Fetch actions (one per entity) ----

export const fetchPreschoolSkillData = (
  queries,
  isPaginating,
  isFiltering,
  entity
) => ({
  type: types.FETCH_PRESCHOOL_SKILL_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPreschoolSkillDataSuccess = (value, entity) => ({
  type: types.FETCH_PRESCHOOL_SKILL_DATA_SUCCESS,
  value,
  entity
})

export const fetchPreschoolWeeklyThemeData = (
  queries,
  isPaginating,
  isFiltering,
  entity
) => ({
  type: types.FETCH_PRESCHOOL_WEEKLY_THEME_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPreschoolWeeklyThemeDataSuccess = (value, entity) => ({
  type: types.FETCH_PRESCHOOL_WEEKLY_THEME_DATA_SUCCESS,
  value,
  entity
})

export const fetchPreschoolWeeklySkillPlanData = (
  queries,
  isPaginating,
  isFiltering,
  entity
) => ({
  type: types.FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPreschoolWeeklySkillPlanDataSuccess = (value, entity) => ({
  type: types.FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA_SUCCESS,
  value,
  entity
})

export const fetchPreschoolMonthlyThemeData = (
  queries,
  isPaginating,
  isFiltering,
  entity
) => ({
  type: types.FETCH_PRESCHOOL_MONTHLY_THEME_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPreschoolMonthlyThemeDataSuccess = (value, entity) => ({
  type: types.FETCH_PRESCHOOL_MONTHLY_THEME_DATA_SUCCESS,
  value,
  entity
})

export const fetchPreschoolAnnualLoData = (
  queries,
  isPaginating,
  isFiltering,
  entity
) => ({
  type: types.FETCH_PRESCHOOL_ANNUAL_LO_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPreschoolAnnualLoDataSuccess = (value, entity) => ({
  type: types.FETCH_PRESCHOOL_ANNUAL_LO_DATA_SUCCESS,
  value,
  entity
})

export const fetchPreschoolSpiralLoData = (
  queries,
  isPaginating,
  isFiltering,
  entity
) => ({
  type: types.FETCH_PRESCHOOL_SPIRAL_LO_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPreschoolSpiralLoDataSuccess = (value, entity) => ({
  type: types.FETCH_PRESCHOOL_SPIRAL_LO_DATA_SUCCESS,
  value,
  entity
})

// ---- Single update action shared across entities ----

export const updatePreschoolData = (entity, event, value) => ({
  type: types.UPDATE_PRESCHOOL_DATA,
  entity,
  event,
  value
})
export const updatePreschoolDataSuccess = (entity, event, value) => ({
  type: types.UPDATE_PRESCHOOL_DATA_SUCCESS,
  entity,
  event,
  value
})
